import { Spinner, Box } from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";

interface LoadingOverlayProps {
  visible: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) setShouldRender(true);
    else {
      const timer = setTimeout(() => setShouldRender(false), 200); // match animation duration
      return () => clearTimeout(timer);
    }
  }, [visible]);

  if (!shouldRender) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      backgroundColor="rgba(0, 0, 0, 0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={9999}
      opacity={visible ? 1 : 0}
      transition="opacity 0.2s ease-in"
    >
      <Box
        width="100px"
        height="100px"
        backgroundColor="black"
        borderRadius="8px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          opacity: visible ? 1 : 0,
          transform: `translateY(${visible ? 0 : 20}px)`,
          transition: "all 0.2s ease-out",
        }}
      >
        <Spinner color="white" size="xl" />
      </Box>
    </Box>
  );
};
